import { Employee } from "../types/processTypes";

export function getEmployeeStatusDate(
  emp: Employee,
): Date | string | undefined {
  return (
    emp.currentStatusDate ??
    emp.additionalData?.discontinuedDate ??
    emp.additionalData?.afterFlightStatusDate
  );
}

export function getEmployeeStatusRemark(emp: Employee): string | undefined {
  return (
    emp.currentStatusRemark ??
    emp.additionalData?.discontinuedRemark ??
    emp.additionalData?.afterFlightStatusRemark
  );
}
